import HttpService from "../base/HttpService";
export default class DistributionService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;

  getDataDistribution(param) {
    const api = this.api + "distribution/main/summary";
    return this.get(param, api);
  }

  getDataDistributionMap(param) {
    const api = this.api + "distribution/main/map";
    return this.get(param, api);
  }

  getDataDistributionDetailMap(param) {
    const api = this.api + `distribution/main/map/${param.metricId}`;
    return this.get(param, api);
  }

  getDataDistributionDetail(param) {
    const api = this.api + `distribution/main/detail/${param.metricId}`;
    return this.get(param, api);
  }

  getDataDistributionNetwork(param) {
    const api = this.api + "distribution/network/summary";
    return this.get(param, api);
  }

  getDataDistributionNetworkDetailRasio(param) {
    const api =
      this.api + "distribution/network/summary/ratio/" + param.metricId;
    return this.get("", api);
  }

  getDataDistributionNetworkDetailJaringan(param) {
    const api = this.api + "distribution/network/summary/jt/" + param.metricId;
    return this.get(param, api);
  }

  getDataDistributionNetworkMap(param) {
    const api = this.api + "distribution/network/map/" + param.metricId;
    return this.get("", api);
  }

  getDataDistributionNetworkMapDetail(param) {
    const api =
      this.api +
      "distribution/network/map/" +
      param.metricId +
      "/" +
      param.provinceId;
    return this.get(param, api);
  }

  getDataDistributionBudget(param) {
    const api = this.api + "distribution/budget/summary";
    return this.get(param, api);
  }

  getDataDistributionBudgetSummaryCard(param) {
    const api = this.api + "distribution/budget/summary/card";
    return this.get(param, api);
  }

  getDataDistributionBudgetDetail(param) {
    const api = this.api + "distribution/budget/summary/" + param.id;
    return this.get(param, api);
  }

  getDataDistributionWorkOrder(param) {
    const api = this.api + "distribution/wo-gangguan/summary";
    return this.get(param, api);
  }

  getDataDistributionWorkOrderDetailRegion(param) {
    const api = this.api + "distribution-work/distribution-work/" + param.id;
    return this.get(param, api);
  }

  getDataDistributionWorkOrderDetailRegionById(param) {
    const api = this.api + "distribution-work/distribution-work/" + param.id;
    return this.get(param, api);
  }

  getDataDistributionWorkOrderDetailUid(param) {
    const api =
      this.api + "distribution-work/distribution-work/uid/" + param.id;
    return this.get(param, api);
  }

  getDataDistributionWorkOrderDetailUp3(param) {
    const api =
      this.api + "distribution-work/distribution-work/uid/up3/" + param.id;
    return this.get(param, api);
  }

  getDataDistributionAssetEvaluation(param) {
    const api = this.api + "distribution/asset/summary";
    return this.get(param, api);
  }

  getDataDetailMetric(param) {
    const api = this.api + `distribution/main/metric/${param.metricId}`;
    return this.get(param, api);
  }

  getDataCardNetwork(param) {
    const api = this.api + `distribution/network/map/detail/${param.cityId}`;
    return this.get('', api);
  }

  getDataChartNetwork(param) {
    const api = this.api + `distribution/network/map/chart/${param.instanceId}`;
    return this.get(param, api);
  }
}
